module.exports = __webpack_public_path__ + "img/weight.ef39a8e5.svg";